export const dayOfWeekMap: { [key: number]: string } = {
  0: "sunday",
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
};

export function currentDateInStoreTimezone(tz: string): string {
  // Returns a string of the date in the store's timezone
  // in the format of M/D/YYYY
  const formatter = Intl.DateTimeFormat("en", {
    timeZone: tz,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  return formatter.format(new Date());
}

export function currentTimeInStoreTimezone(tz: string): string {
  // Returns string in HH:MM format
  const formatter = Intl.DateTimeFormat("en", {
    timeZone: tz,
    hour: "numeric",
    hour12: false,
    minute: "numeric",
  });
  return formatter.format(new Date());
}

export function findNextOpenDayOffset(dayOfWeekIndex: number, hours: { [index: string]: string | null }): number | null {
  // Starting from the following day of week, find the day with open hours.
  for (let i = 1; i <= 6; i++) {
    const nextDayIndex = (dayOfWeekIndex + i) % 7;
    const nextDay = dayOfWeekMap[nextDayIndex];
    if (hours[`${nextDay}_start`]) {
      return i;
    }
  }

  return null;
}

export function calculateDaysFrom(currentDate: Date, daysToAdd: number): Date {
  const currentDateCopy = new Date(currentDate);
  currentDateCopy.setDate(currentDateCopy.getDate() + daysToAdd);

  return currentDateCopy;
}

export function getTimezoneOffset(timezone: string): string | null {
  // `timezone` is an IANA timezone string, e.g. "America/New_York" 
  // Returns long offset timezone, e.g. "GMT-05:00"
  const formatter = Intl.DateTimeFormat("en", {
    timeZone: timezone,
    timeZoneName: "longOffset",
  });
  const parts = formatter.formatToParts(new Date());

  if (!parts) {
    return null;
  }

  const found = parts?.find(
    (part) => part.type === "timeZoneName"
  );
  return found?.value || null;
}

export function constructDateFromTimezone(date: Date, time: string, timezone: string) {
  // `time` is in HH:MM format
  // `timezone` is an IANA timezone string, e.g. "America/New_York" 
  const offset = getTimezoneOffset(timezone) || '';
  const year = date.getFullYear();
  const month = date.getMonth();
  const dateDate = date.getDate();

  const dateString = `${year}-${month + 1}-${dateDate}`;
  // e.g. "Jan 20 2012 11:51 GMT-05:00"
  var constructedDate = new Date(
    `${dateString} ${time} ${offset}`,
  );

  // For Safari and Chrome, dates need to look like 2025/1/13 instead of
  // 2025-1-13
  if (isNaN(constructedDate.getTime())) {
    constructedDate = new Date(
      `${dateString.replace(/-/g, "/")} ${time} ${offset}`,
    );
  }

  return constructedDate;
}

export function formatToCustomerLocale(date: Date) {
  const formatter = Intl.DateTimeFormat(navigator.languages, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
  return formatter.format(date);
}
